
// SVG Icon: expand
export default { id: "terriajs-expand" };
export const id = "terriajs-expand";
export const name = "expand";
